export default "/images/company5.jpg?ab4d80937bafab00846387166c19e1f1";